import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

// services
import { ErrorsService } from './errors.service';

@NgModule({
  imports: [CommonModule],
})
export class ErrorsModule {
  static forRoot(): ModuleWithProviders<ErrorsModule> {
    return {
      ngModule: ErrorsModule,
      providers: [ErrorsService],
    };
  }
}
